import React, { useState } from "react";
import { Button } from "../../../../../../../../components/ui/Button";
import I18n from "../../../../../../../localization/I18n";
import { useModalContext } from "../../../../../../../modalZ/context/ModalContext";
import TagsApi from "../../../../../../../../services/api/v2/tags/Tags.api";
import { getProjectStakeholderTagFormFields } from "./ProjectStakeholderTagsSidebar_formFields";
import { SingleFormModel } from "../../../../../../../../pages/change/forms/singleFormModel/SingleForm_model";
import { SingleForm } from "../../../../../../../../pages/change/forms/singleFormModel/SingleForm_view";

interface ManageProjectStakeholderTagFormProps {
  organisationId: number;
  projectId: number;
  projectStakeholder: FP.Entities.IProjectStakeholder;
}

class ManageProjectStakeholderTagFormModel {
  formModel: SingleFormModel;

  constructor(organisationId: number, projectId: number, projectStakeholder: FP.Entities.IProjectStakeholder) {
    this.formModel = new SingleFormModel();

    const tagsProvider = TagsApi;
    let formFields = getProjectStakeholderTagFormFields(tagsProvider, organisationId, projectId, projectStakeholder);
    this.formModel.formFields = formFields;
  }
}

export const ManageStakeholderTagForm: React.FC<ManageProjectStakeholderTagFormProps> = props => {
  const { projectStakeholder, projectId, organisationId } = props;
  const modalService = useModalContext();

  let [model] = useState(() => new ManageProjectStakeholderTagFormModel(organisationId, projectId, projectStakeholder));

  return (
    <div>
      <SingleForm model={model.formModel} />
      <div className="row mb-5">
        <div className="col">
          <div className="d-flex">
            <Button
              className="ml-auto"
              onClick={() => {
                modalService.hide();
              }}
            >
              {I18n.t("phrases.done")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
